import { IndexSignUpCtaComponentMainDiv } from "../../styles/indexcomponentsstyles/indexsingupctacomponentstyles";
import ButtonComponentVariant from "../reusable/header/assetes/buttoncomponents/buttoncomponentvarint";
import ButtonComponent from "../reusable/header/assetes/buttoncomponents/butttoncomponent";
import { openVsCodeExtension } from "../../utils/vscodeLauncher";
import Logo from "./assets/bugzi logo 2.png";
const IndexSignUpCtaComponent = () => {
  return (
    <IndexSignUpCtaComponentMainDiv>
      <div>
        <div className="singup-cta-container">
          <div className="singup-cta-wrapper">
            <div>
              <div className="singup-cta-icon-wraper">
                <img src={Logo} alt=" " />
              </div>
            </div>
            <div className="cta-bottom-contaner">
              <div className="cta-header-contaner">
                <div>
                  <div className="cta-text-wrapper">
                    <h2>Ready to Do More with AI Today</h2>
                  </div>
                </div>

                <div>
                  <div className="cta-text-wrapper">
                    <p>
                     "Sign up for Bugzi AI and bring powerful AI models into your favorite IDE—start building smarter, faster.
                    </p>
                  </div>
                </div>
              </div>

              <div className="cta-button-contaier">
                <div className="cta-button-wrapper">
                  <ButtonComponent title="Get started-free" onclick={openVsCodeExtension} />
                </div>
                <div className="cta-button-wrapper">
                  <ButtonComponentVariant title="View Pricing " link="/pricing" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </IndexSignUpCtaComponentMainDiv>
  );
};

export default IndexSignUpCtaComponent;


